import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import {
  Area,
  Challenge,
  CreateIdeaCountryInput,
  CreateKaizenIdeaGQL,
  CreateIdeaKaizenInput,
  GetAreasGQL,
  GetAreasQuery,
  GetChallengesByLanguageGQL,
  GetChallengesByLanguageQuery,
  GetCountriesGQL,
  GetCountriesQuery,
  GetUnitiesByCountryGQL,
  GetUnitiesByCountryQuery,
  MeGQL,
  GetUnitiesGQL,
  ChallengeType,
  CreateIdeaChallenge,
} from "../../../generated/graphql";
import { QueryRef } from "apollo-angular";
import { BaseComponent } from "../../base/base.component";
import { Router } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import {
  EmitEvent,
  EventBusService,
  Events,
} from "../../service/event-bus.service";
import { Frames } from "src/utils/frame";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import {
  IInforImage,
  IModelAuthorDetail,
  IUnity,
} from "./interfaces/register-kaizen-idea.interface";
import { GetEmployeeByReGQL } from "graphql/employee/employee.definition";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { IdeaAttachmentService } from "../../service/idea-attachment.service";
import {
  KAIZEN_CARD_DIR,
  MAX_IDEA_ATTACHMENTS,
} from "../../components/idea-attachments/idea-attachments.constants";

declare var $: any;

@Component({
  selector: "app-register-kaizen-idea",
  templateUrl: "./register-kaizen-idea.component.html",
  styleUrls: ["./register-kaizen-idea.component.scss"],
})
export class RegisterKaizenIdeaComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  subscription: Subscription;
  page: string = "description";

  model: CreateIdeaKaizenInput = new CreateIdeaKaizenInput();
  canRegisterKaizen = false;
  modelAuthorDetail: IModelAuthorDetail = {
    name: "",
    re: "",
    email: "",
  };

  modelEmailConfirm = null;

  challenges: Challenge[] = [];
  challengesQuery: QueryRef<GetChallengesByLanguageQuery>;

  countries: Observable<any>;
  countriesQuery: QueryRef<GetCountriesQuery>;

  countriesUnity: Observable<any>;
  countriesUnityQuery: QueryRef<GetUnitiesByCountryQuery>;
  selectedCountry: any;

  areas: Array<Area> = [];
  areasQuery: QueryRef<GetAreasQuery>;
  userId: string;
  modelAreas: string[] = [
    "Qualidade",
    "Segurança",
    "Produção",
    "Manutenção",
    "Outros",
  ];

  private destroy$ = new Subject<void>();

  private file: File;
  image: string;
  eventImage: Event;
  // imagem do cartão Kaizen (conceito próprio: alternativa a Problema + Solução)
  cardFile: File | null = null;
  // anexos adicionais (imagem/PDF); o cartão também conta no limite do backend
  attachments: File[] = [];
  frames: Frames[];
  selectedAreas: string[] = [];

  inforImage: IInforImage;

  recordStream: boolean = false;
  unities: IUnity[] = [];
  unityId: string = "";
  language: string = "";

  constructor(
    public router: Router,
    public translate: TranslateService,
    private eventbus: EventBusService,
    private getAreasGQL: GetAreasGQL,
    private getChallengesByLanguageGQL: GetChallengesByLanguageGQL,
    private getCountriesGQL: GetCountriesGQL,
    private createKaizenIdeaGQL: CreateKaizenIdeaGQL,
    private meDocument: MeGQL,
    private getUnitiesByCountryGQL: GetUnitiesByCountryGQL,
    private http: HttpClient,
    private ideaAttachmentService: IdeaAttachmentService,
    public unitiesGQL: GetUnitiesGQL,
    private employeeGQL: GetEmployeeByReGQL,
  ) {
    super(router, translate);
    this.subscription = this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        $(() => {
          this.language = localStorage.getItem("culture");
          this.challengesQuery.refetch({
            language: localStorage.getItem("culture"),
          });
        });
      });

    this.getAllFrames();
    this.actionListUnity();
  }

  ngOnDestroy(): void {
    $(".header").removeClass("d-none");
    $(".footer").removeClass("d-none");
    const newAuthor = $("#newAuthor");
    if (newAuthor[0]) {
      newAuthor.remove();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    // Mesmo gate do botão da Home: só admin ou participante de comitê Kaizen.
    const isAdmin = localStorage.getItem("role") === "admin";
    const isKaizenMember = localStorage.getItem("kaizen") === "true";
    this.canRegisterKaizen = isAdmin || isKaizenMember;
    if (!this.canRegisterKaizen) {
      this.router.navigate(["/home"]);
      return;
    }
    $(".header").addClass("d-none");
    $(".footer").addClass("d-none");
    this.language = localStorage.getItem("culture");
    this.recordStream = this.handlerRegister();
    this.model.authors = [];
    this.challengesQuery = this.getChallengesByLanguageGQL.watch({
      language: this.language,
    });
    this.getAreas();
    this.challengesQuery.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ data }) => {
        this.challenges = data.getChallengesByLanguage as Challenge[];
        this.model.challenge = new CreateIdeaChallenge();
        this.model.challenge!.language = localStorage.getItem("culture");
        if (this.challenges.length > 0) {
          const title =
            this.language === "pt-BR" ? "Sem Desafio" : "SIN DESAFÍO";
          this.model.challenge!.id = this.challenges.find((item) => {
            return item.title === title;
          }).id;
        }
      });
    this.countriesQuery = this.getCountriesGQL.watch();
    this.countries = this.countriesQuery.valueChanges.pipe(
      map((result) => result.data.getCountries),
    );
  }

  getAllFrames() {
    this.http
      .get(`${environment.base_url}/frame`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: Frames[]) => {
          this.frames = response;
        },
        (error: unknown) => {
          console.log("Get frames error: ", error);
        },
      );
  }

  ngAfterViewInit() {
    if (!this.canRegisterKaizen) {
      return;
    }
    const re = localStorage.getItem("re");
    re ? this.getEmployeeId(re) : this.getUserId();
  }

  getEmployeeId(re: string) {
    let employeeQuery = this.employeeGQL.watch({ re });
    employeeQuery.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
      next: ({ data }) => {
        this.model.employeeId = data.getEmployeeRe.id;
      },
      error: () => {
        this.showMessage(
          this.translate.instant("attention"),
          this.translate.instant("ReError"),
          "warning",
        );
      },
    });
  }

  getUserId() {
    let userQuery = this.meDocument.watch();
    userQuery.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((dataUser) => {
        this.model.userId = dataUser.data.me.id;
      });
  }

  handlerRegister() {
    return this.router.url === "/register";
  }

  onBackModal(page: string) {
    this.page = page;

    const re = localStorage.getItem("re");
    re ? this.getEmployeeId(re) : this.getUserId();
  }

  onNextModal(page: string) {
    this.page = page;
    if (page === "finish") {
      setTimeout(() => {
        $(".idea-finish_col-primary").css("max-width", "100%");
        $(".idea-finish_col-secondary").css("border-radius", "10px 0 0 10px");
      }, 250);
      setTimeout(() => {
        $(".idea-finish_col-secondary_padding").css("opacity", "1");
      }, 500);
    }
    if (page === "challenge") {
      $("#idea").modal("hide");
      this.router.navigate(["/"]);
    }
  }

  // STEP 1
  stepOneChallenge(id: string, type: ChallengeType) {
    this.model.challenge = {
      id,
      type,
      language: localStorage.getItem("culture"),
    };
  }

  onStepSaveOne() {
    if (this.isNullOrUndefined(this.model.challenge)) {
      this.showMessage(
        this.translate.instant("attention"),
        this.translate.instant("challengeSelect"),
      );
      return;
    }
    this.onNextModal("description");
  }

  // STEP 2
  onChangeArea(event: Event, area: string) {
    event.stopPropagation();

    const selectedValue = area;

    const optionIndex = this.selectedAreas.indexOf(selectedValue);

    this.selectedAreas.includes(selectedValue)
      ? this.selectedAreas.splice(optionIndex, 1)
      : this.selectedAreas.push(selectedValue);
  }

  async onStepSaveSecond() {
    this.model.unity = {
      id: this.unityId,
    };

    let arrValidateFields = [
      {
        value: this.model.authorName,
        text: this.translate.instant("ideaMaker.ideaAuthor") + ", <br />",
      },
      {
        value: this.model.unity,
        text: this.translate.instant("ideaMaker.unity") + ", <br />",
      },
      {
        value: this.model.re,
        text: this.translate.instant("ideaMaker.ideaRe") + ", <br />",
      },
      {
        value: this.model.initialDate,
        text: this.translate.instant("ideaMaker.createdAt") + ", <br />",
      },
      {
        value: this.model.frame,
        text: this.translate.instant("ideaMaker.ideaFrame") + ", <br />",
      },
      {
        value: this.model.title,
        text: this.translate.instant("ideaMaker.ideaTitle") + ", <br />",
      },
    ];

    if (!this.image) {
      arrValidateFields.push(
        {
          value: this.model.problem,
          text: this.translate.instant("ideaMaker.ideaProblem") + ", <br />",
        },
        {
          value: this.model.solution,
          text: this.translate.instant("ideaMaker.ideaSolution") + ", <br />",
        },
      );
    }

    if (!(this.model.problem && this.model.solution) && !this.image) {
      arrValidateFields.push({
        value: this.image,
        text: this.translate.instant("Cartão kaizen") + ", <br />",
      });
    }

    // AREA
    if (this.selectedAreas.length == 0) {
      arrValidateFields.push({
        value: this.model.area,
        text: this.translate.instant("ideaMaker.ideaArea") + ", <br />",
      });

      const stringErrorExpectation = this.validateField(arrValidateFields);
      if (!super.isNullOrUndefined(stringErrorExpectation)) {
        this.showMessage(
          this.translate.instant("attention"),
          this.translate.instant("required") +
            `<br><br> ${stringErrorExpectation}`,
        );
        return;
      }
    }

    this.model.area = this.selectedAreas.join();

    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      const message =
        "Preencher: Problema e possível solução ou inserir a imagem do cartão Kaizen";
      this.showMessage(
        this.translate.instant("attention"),
        this.translate.instant("required") +
          `<br><br> ${stringError}<br><br> <p style="color: red;">${message}</p> `,
      );
      return;
    }

    $("#loaderBox").fadeIn();
    this.createKaizenIdeaGQL.mutate({ data: this.model }).subscribe(
      async (response) => {
        const { id } = response.data.createIdeaKaizen;
        // cartão (se ainda selecionado) e anexos; falha de um não impede os demais
        const results = [
          ...(this.cardFile
            ? await this.ideaAttachmentService.uploadAll("kaizen", id, [this.cardFile], KAIZEN_CARD_DIR)
            : []),
          ...(this.attachments.length
            ? await this.ideaAttachmentService.uploadAll("kaizen", id, this.attachments)
            : []),
        ];
        this.attachments = [];
        this.cardFile = null;
        this.model = new CreateIdeaKaizenInput();
        this.eventImage = null;
        this.image = "";
        this.modelAuthorDetail = null;
        this.modelEmailConfirm = null;
        this.modelAreas = [
          "Qualidade",
          "Segurança",
          "Produção",
          "Manutenção",
          "Outros",
        ];
        this.onNextModal("finish");
        this.eventbus.emit(new EmitEvent(Events.isUpdateIdea, true));
        $("#loaderBox").fadeOut();
        const summary = this.ideaAttachmentService.summarize(results);
        if (summary) {
          this.showMessage(this.translate.instant("attachments.summaryTitle"), summary.html, summary.type);
        }
      },
      (error) => {
        this.showMessage("Error:", error);
      },
    );
  }

  // STEP 3
  onStepSaveThree() {
    const arrValidateFields = [
      {
        value: this.model.authorName,
        text: this.translate.instant("author.name") + ", <br />",
      },
      { value: this.model.document, text: "Cargo, <br />" },
      { value: this.model.re, text: "RE, <br />" },
      {
        value: this.model.turn,
        text: this.translate.instant("author.period") + ", <br />",
      },
      {
        value: this.model.managerName,
        text: this.translate.instant("author.superior") + ", <br />",
      },
      {
        value: this.model.phone,
        text: this.translate.instant("author.phone") + ", <br />",
      },
      {
        value: this.model.phoneExtensionLine,
        text: this.translate.instant("author.cell") + ", <br />",
      },
      {
        value: this.model.costCenter,
        text: this.translate.instant("author.costCenter") + ", <br />",
      },
      {
        value: this.model.contactHour,
        text: this.translate.instant("author.bestTime") + "<br />",
      },
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        this.translate.instant("attention"),
        this.translate.instant("required") + `<br><br> ${stringError}`,
      );
      return;
    }

    this.onNextModal("unity");
  }

  onAddAuthor() {
    if (!this.isEMailValid(this.modelAuthorDetail.email)) {
      return;
    }
    if (!this.model.authors) {
      this.model.authors = [];
    }
    const authorsFiltered = this.model.authors?.filter(
      (author) => author.name === this.modelAuthorDetail.name,
    );

    if (authorsFiltered.length === 0) {
      this.model.authors.push({
        name: this.modelAuthorDetail.name,
        re: this.modelAuthorDetail.re.toString(),
        cpf: this.modelAuthorDetail.cpf || null,
        costCenter: this.modelAuthorDetail.costCenter || null,
        jobRole: this.modelAuthorDetail.jobRole || null,
        area: this.modelAuthorDetail.area || null,
        email: this.modelAuthorDetail.email,
      });

      this.modelAuthorDetail = {
        name: "",
        re: "",
        email: "",
      };
    }
  }

  onRemoveAuthor(i: number) {
    this.confirmMessage(
      this.translate.instant("attention"),
      "Deseja realmente remover o autor?",
      () => {
        this.model.authors.splice(i, 1);
      },
    );
  }

  // STEP 4
  onGetUnityByCountry(i: any) {
    this.selectedCountry = i;
    this.countriesUnity = this.getUnitiesByCountryGQL
      .watch({ id: i.id })
      .valueChanges.pipe(takeUntil(this.destroy$))
      .pipe(map((result) => result.data.getUnitiesByCountry));
    this.model.unity = null;
    const countryIf: CreateIdeaCountryInput = { id: i.id };
    this.model.country = countryIf;
  }

  onChangeUnity($event: Event) {
    this.model.unity = { id: $($event.srcElement).val() };
  }

  onStepSaveFour() {
    if (this.isNullOrUndefined(this.model.unity)) {
      this.showMessage(
        this.translate.instant("attention"),
        this.translate.instant("selectcountry"),
      );
      return;
    }
    this.onNextModal("productiveEquipment");
  }

  // STEP 5
  onStepSaveFive() {
    if (this.isNullOrUndefined(this.model.productiveEquipament)) {
      this.showMessage(
        this.translate.instant("attention"),
        this.translate.instant("selectoption"),
      );
      return;
    }
    if (this.model.productiveEquipament) {
      if (this.isNullOrUndefined(this.model.productiveDescription)) {
        this.showMessage(
          this.translate.instant("attention"),
          this.translate.instant("selectproceed"),
        );
        return;
      }
    }
    this.onNextModal("responsibleArea");
  }

  // STEP 6
  onStepSaveSix() {
    const arrValidateFields = [
      { value: this.model.areaResponsible, text: "Área Principal, <br />" },
      { value: this.model.areaExtensionLine, text: "Ramal, <br />" },
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        this.translate.instant("attention"),
        this.translate.instant("required") + `<br><br> ${stringError}`,
      );
      return;
    }
    this.onNextModal("contact");
  }

  onImageChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.file = inputElement?.files[0];
    this.eventImage = event;

    const validImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
    ];
    if (this.file && validImageTypes.includes(this.file.type)) {
      const sizeInKB = this.file.size / 1024;
      const sizeInMB = sizeInKB / 1024;

      this.inforImage = {
        type: `Image.${this.file.type.split("/")[1]}`,
        size:
          sizeInMB >= 1
            ? `${sizeInMB.toFixed(2)} MB`
            : `${sizeInKB.toFixed(2)} KB`,
      };

      this.cardFile = this.file;
      this.convertToBase64(this.file);
    } else {
      this.showMessage(
        this.translate.instant("attention"),
        this.translate.instant("fileError"),
      );
    }
  }

  toRemoveImage() {
    this.image = "";
    this.cardFile = null;
  }

  /** Vagas de anexo: o cartão, se houver, ocupa uma das 10 do backend. */
  get attachmentSlots(): number {
    return MAX_IDEA_ATTACHMENTS - (this.cardFile ? 1 : 0);
  }

  convertToBase64(file: File): void {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String: string = reader.result as string;
      this.image = base64String;
    };
    reader.readAsDataURL(file);
  }

  openModalAuthor(id: string) {
    $("#" + id).modal("show");
  }

  private getAreas() {
    this.areasQuery = this.getAreasGQL.watch();
    this.areasQuery.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ data }) => {
        this.areas = data.areas as Array<Area>;
      });
  }

  onInputChange(value: string) {
    const filteredValue = value.replace(/[^a-zA-Z0-9\s-]/g, "");

    const filteredValueReplacesWhiteSpace = filteredValue.replace(
      /[a-zA-Z]/g,
      "",
    );

    const filteredValueRemoveConsecutiveHyphens =
      filteredValueReplacesWhiteSpace.replace(/-{2,}/g, "-");

    const filteredValueRemoveHyphens =
      filteredValueRemoveConsecutiveHyphens.replace(/^-|-$/g, "");

    const formattedValue = filteredValueRemoveHyphens.replace(/\s+/g, "-");

    if (this.model.otherAuthors !== formattedValue) {
      this.model.otherAuthors = formattedValue;
    }
  }

  actionListUnity() {
    this.unitiesGQL
      .watch()
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(({ data }) => {
        this.unities = data.getUnities;
      });
  }
}
